import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const ru = {
  nav: {
    dashboard: 'Дашборд', content: 'Контент-фабрика', channels: 'Каналы',
    exchange: 'Биржа', analytics: 'Аналитика', farm: 'Ферма', bots: 'Боты',
    settings: 'Настройки', billing: 'Тариф',
  },
  common: {
    loading: 'Загрузка…', error: 'Ошибка', save: 'Сохранить', cancel: 'Отмена',
    delete: 'Удалить', edit: 'Изменить', signOut: 'Выйти',
  },
  dashboard: {
    title: 'Дашборд',
    period: { '7d': '7 дней', '30d': '30 дней', '90d': '90 дней' },
    cards: { subscribers: 'Подписчики', reach: 'Охват за 7 дней', er: 'Средний ER', scheduled: 'Запланировано', farm: 'Аккаунты фермы' },
    chartTitle: 'Рост подписчиков (30 дней)',
    upcomingTitle: 'Ближайшие посты',
    upcomingEmpty: 'Нет запланированных постов',
    insightsTitle: 'AI Insight дня',
    insight: { best: 'Лучший пост вчера', trend: 'Тренд дня', recommendation: 'Рекомендация' },
    emptyTitle: 'Начнём за 3 шага',
    emptySubtitle: 'Подключи Telegram-канал и начни публиковать контент',
    startWizard: 'Запустить мастер настройки',
    step1: 'Подключи Telegram-канал',
    step2: 'Посмотри аналитику',
    step3: 'Запланируй первый пост',
    errorLoad: 'Не удалось загрузить данные дашборда',
  },
  login: {
    title: 'Вход в teleclaw',
    email: 'Email', password: 'Пароль', signIn: 'Войти', googleSignIn: 'Войти через Google',
  },
  billing: {
    title: 'Тариф и оплата',
    currentPlan: 'Текущий тариф',
    renewsOn: 'Продление',
    cancelSubscription: 'Отменить подписку',
    usage: { posts: 'Посты', channels: 'Каналы', ai: 'AI-вызовы' },
    choosePayment: 'Способ оплаты',
    plans: 'Тарифы',
    popular: 'Популярный',
    perMonth: 'мес',
    upgrade: 'Перейти',
    farmAddons: 'Фермы (доп.)',
    accounts: 'аккаунтов',
    addAddon: 'Подключить',
    history: 'История платежей',
    noHistory: 'Платежей пока нет',
    col: { date: 'Дата', amount: 'Сумма', tariff: 'Тариф', status: 'Статус', invoice: 'Инвойс' },
    referral: {
      title: 'Реферальная программа',
      yourLink: 'Твоя реферальная ссылка',
      copy: 'Копировать',
      invited: 'Приведено',
      earned: 'Заработано',
    },
    redirecting: 'Переходим к оплате…',
    chargeFailed: 'Не удалось создать платёж',
    cancelled: 'Подписка отменена',
    copied: 'Скопировано',
  },
  onboarding: {
    skip: 'Пропустить',
    back: 'Назад',
    next: 'Далее',
    finishToast: 'Добро пожаловать в teleclaw!',
    step1: {
      title: 'Канал',
      heading: 'Подключи Telegram-канал',
      desc: 'Введи Bot Token, который выдал @BotFather. Он нужен, чтобы публиковать посты от имени канала.',
      tokenLabel: 'Bot Token',
      connect: 'Validate & Connect',
      connected: 'Канал подключён',
      invalid: 'Введи корректный Bot Token',
      subs: 'подписчиков',
      helpLink: 'Как получить Bot Token?',
      helpTitle: 'Получение Bot Token',
      help1: 'Открой @BotFather в Telegram',
      help2: 'Отправь команду /newbot',
      help3: 'Следуй инструкциям и придумай имя бота',
      help4: 'Скопируй выданный токен и вставь сюда',
    },
    step2: {
      title: 'Аналитика',
      heading: 'Посмотри аналитику',
      baseline: 'Это твоя точка отсчёта — дальше будем расти.',
      subscribers: 'Подписчики',
      er: 'ER',
      reach: 'Охват',
      lastPost: 'Последний пост',
    },
    step3: {
      title: 'Первый пост',
      heading: 'Запланируй первый пост',
      desc: 'Напиши пост и выбери время публикации.',
      text: 'Текст поста',
      publishAt: 'Опубликовать',
      useAi: 'Использовать AI',
      aiPrompt: 'О чём пост?',
      aiGenerate: 'Сгенерировать',
      aiDone: 'AI сгенерировал текст',
      schedule: 'Запланировать первый пост',
    },
  },
  share: {
    title: 'Первый пост в очереди! 🎉',
    desc: 'Ты только что запланировал первый пост через teleclaw. Поделись результатом и приглашай коллег.',
    shareTelegram: 'Поделиться в Telegram',
    tgText: 'Веду канал {{handle}} через teleclaw — планирование, аналитика и рост в одном месте. Попробуй:',
    referralHeading: 'Приглашай и получай бонус',
    referralDesc: 'Пригласи коллегу — вы оба получите бонусные кредиты при его первой оплате.',
    copy: 'Копировать',
    copied: 'Ссылка скопирована',
    later: 'Позже',
  },
  publicChannel: {
    tagline: 'Telegram Content Factory & Marketing Suite',
    subscribers: 'Подписчики',
    er: 'ER (7д)',
    growth: 'Рост (30д)',
    cta: 'Попробовать teleclaw бесплатно',
    notFound: 'Канал не найден или скрыт',
  },
  wall: {
    posts: {
      title: 'Лимит постов исчерпан',
      desc: 'На тарифе Free доступно 30 постов в месяц. Обнови тариф, чтобы публиковать без ограничений.',
    },
    ai: {
      title: 'AI-функции недоступны на Free',
      desc: 'AI-контент и fine-tune доступны с тарифа Starter.',
    },
    channels: {
      title: 'Достигнут лимит каналов',
      desc: 'Обнови тариф, чтобы подключить больше каналов.',
    },
    usage: 'Использовано {{used}} из {{limit}}',
    cta: 'Посмотреть тарифы',
  },
  nps: {
    title: 'Насколько вероятно, что вы порекомендуете teleclaw коллеге?',
    notLikely: 'Маловероятно',
    veryLikely: 'Очень вероятно',
    commentPlaceholder: 'Что можно улучшить? (необязательно)',
    submit: 'Отправить',
    dismiss: 'Не сейчас',
    thanks: 'Спасибо за отзыв!',
  },
  content: {
    trends: 'Тренды',
    selectChannel: 'Выбери канал',
    noChannel: 'Сначала выбери канал',
    aiPlan: 'AI-план',
    newPost: 'Новый пост',
    untitled: '(без текста)',
    empty: { trends: 'Трендов пока нет' },
    toast: {
      created: 'Пост создан', updated: 'Сохранено', deleted: 'Удалено',
      aiImproved: 'AI обновил текст', planApplied: 'План добавлен в календарь',
    },
    editor: {
      title: 'Редактор поста', text: 'Текст', media: 'Медиа URL',
      time: 'Время публикации', channel: 'Канал', schedule: 'Запланировать',
      aiTitle: 'AI-улучшить', aiRewrite: 'Перепиши', aiShorter: 'Короче', aiCta: 'Добавь CTA',
    },
    plan: {
      topic: 'Тема', audience: 'Аудитория', days: 'Дней', perDay: 'Постов в день',
      language: 'Язык', generate: 'Сгенерировать', applyAll: 'Добавить все в календарь',
      preview: 'Предложения',
    },
  },
  farm: {
    title: 'Ферма',
    selector: 'Выбор фермы',
    all: 'Все фермы',
    importSessions: '+ Импорт сессий',
    runScript: 'Запустить скрипт',
    locked: {
      title: 'Farm-функции недоступны',
      description: 'Farm features недоступны на вашем тарифе. Обновитесь, чтобы получить доступ к ферме аккаунтов.',
      upgrade: 'Обновить тариф',
    },
    status: {
      active: 'Активен', warming: 'Прогрев', banned: 'Бан',
      recovered: 'Восстановлен', idle: 'Покой',
    },
    cards: {
      total: 'Всего аккаунтов', active: 'Активных', warming: 'На прогреве',
      banned: 'Забанено', recovered: 'Восстановлено сегодня',
    },
    scripts: {
      title: 'Библиотека скриптов',
      warm: 'Warm (30д)',
      invite_conservative: 'Invite — консервативно',
      invite_aggressive: 'Invite — агрессивно',
      comment: 'Comment',
      react: 'React',
      stories_mention: 'Stories Mention',
      customTitle: 'Кастомный скрипт',
      customHint: 'No-code конструктор: Action → Delay → Condition → Loop',
    },
    table: {
      title: 'Аккаунты (real-time)',
      empty: 'Аккаунтов нет — импортируйте сессии',
      username: 'Username', status: 'Статус', proxy: 'Прокси',
      warming: 'Прогрев', lastAction: 'Последнее действие', actions: 'Действия',
    },
    details: {
      title: 'Детали аккаунта',
      status: 'Статус', proxy: 'Прокси', warming: 'Прогрев (дней)',
      lastAction: 'Последнее действие', activity: 'Активность (14 дней)',
      recover: 'Восстановить аккаунт',
    },
    proxy: {
      title: 'Прокси-пул',
      success: 'Успех',
      empty: 'Прокси не подключены',
    },
    alert: {
      banSpike: '10% аккаунтов забанено за час — все скрипты приостановлены',
    },
    toast: {
      imported: 'Сессии импортированы',
      importFailed: 'Не удалось импортировать сессии',
      scriptStarted: 'Скрипт запущен',
      scriptFailed: 'Не удалось запустить скрипт',
      recoverQueued: 'Восстановление поставлено в очередь',
      recoverFailed: 'Не удалось запустить восстановление',
    },
  },
  settings: {
    title: 'Настройки',
    tabs: {
      profile: 'Профиль', team: 'Команда', whitelabel: 'White-label',
      apikeys: 'API ключи', webhooks: 'Webhooks', referral: 'Реферальная программа',
      danger: 'Опасная зона',
    },
    profile: {
      email: 'Email', fullName: 'Полное имя', telegram: 'Telegram username',
      language: 'Язык', saved: 'Профиль сохранён',
    },
    team: {
      members: 'Участники', invite: 'Пригласить', send: 'Отправить',
      colEmail: 'Email', colRole: 'Роль', colJoined: 'Присоединился',
      empty: 'Пока нет участников', pending: 'Ожидающие приглашения',
      noPending: 'Нет ожидающих приглашений', invited: 'Приглашение отправлено',
      removed: 'Участник удалён',
    },
    whitelabel: {
      domain: 'Домен', logo: 'Логотип', primary: 'Основной цвет',
      accent: 'Акцентный цвет', emailTpl: 'Email шаблоны',
      preview: 'Предпросмотр', saved: 'White-label сохранён',
    },
    apikeys: {
      title: 'API ключи', generate: 'Сгенерировать ключ',
      colName: 'Название', colPrefix: 'Префикс', colScopes: 'Scopes',
      colLastUsed: 'Последнее использование', empty: 'Нет API ключей',
      created: 'Ключ создан', warning: 'Сохрани этот ключ сейчас. Он больше не будет показан.',
      copied: 'Скопировано', acknowledge: 'Я сохранил', revoked: 'Ключ отозван',
    },
    webhooks: {
      title: 'Webhooks', add: 'Добавить webhook', events: 'События',
      empty: 'Нет webhooks', lastTriggered: 'Последний вызов',
      never: 'Ещё не вызывался', added: 'Webhook добавлен',
    },
    referral: {
      code: 'Реферальный код', referred: 'Приведено пользователей',
      earned: 'Заработано', payouts: 'История выплат',
      noPayouts: 'Пока нет выплат', copied: 'Скопировано',
    },
    danger: {
      title: 'Опасная зона',
      exportTitle: 'Скачать все данные',
      exportDesc: 'GDPR-экспорт (JSON): профиль, каналы, посты, подписки, платежи, API-ключи. Скачается сразу.',
      exportBtn: 'Скачать экспорт', exportQueued: 'Экспорт скачан',
      deleteTitle: 'Удалить аккаунт',
      deleteDesc: 'Это действие необратимо. Все данные будут удалены.',
      deleteBtn: 'Удалить аккаунт',
      confirm1: 'Вы уверены? Это удалит все каналы, посты, ботов и подписку.',
      confirmYes: 'Да, продолжить',
      typeDelete: 'Введите DELETE для подтверждения',
      deleteFinal: 'Удалить навсегда', deleted: 'Аккаунт удалён',
    },
  },
  bots: {
    title: 'Боты',
    create: 'Создать бота',
    search: 'Поиск ботов…',
    empty: 'У вас пока нет ботов',
    namePlaceholder: 'Имя бота',
    typePlaceholder: 'Тип',
    status: {
      draft: 'Черновик',
      deployed: 'Запущен',
      paused: 'Пауза',
      error: 'Ошибка',
    },
    type: {
      support: 'Поддержка',
      sales: 'Продажи',
      faq: 'FAQ',
      lead: 'Лидогенерация',
      generic: 'Общий',
    },
    lastActivity: 'Последняя активность',
    open: 'Открыть',
    duplicate: 'Дублировать',
    delete: 'Удалить',
    deploy: 'Развернуть',
    pause: 'Пауза',
    resume: 'Запустить',
    save: 'Сохранить',
    saved: 'Сохранено',
    deployed: 'Бот развёрнут',
    paused: 'Бот приостановлен',
    resumed: 'Бот возобновлён',
    created: 'Бот создан',
    deleted: 'Бот удалён',
    testRun: 'Тест-запуск',
    testInput: 'Сообщение от пользователя',
    testStart: 'Запустить тест',
    testTrace: 'Трассировка',
    back: 'Назад к списку',
    nodes: {
      title: 'Типы нод',
      message: 'Сообщение',
      input: 'Ввод',
      condition: 'Условие',
      api_call: 'API вызов',
      delay: 'Задержка',
      payment_request: 'Платёж',
      faq_query: 'FAQ',
      end: 'Конец',
    },
    props: {
      title: 'Свойства',
      none: 'Выберите ноду',
      text: 'Текст',
      buttons: 'Кнопки',
      addButton: 'Добавить кнопку',
      buttonText: 'Текст',
      callbackData: 'callback_data',
      variable: 'Имя переменной',
      validation: 'Тип валидации',
      operator: 'Оператор',
      value: 'Значение',
      url: 'URL',
      method: 'Метод',
      headers: 'Заголовки (JSON)',
      body: 'Тело (шаблон)',
      amount: 'Сумма',
      currency: 'Валюта',
      planId: 'ID плана',
      delayMs: 'Задержка (мс)',
      knowledgeBase: 'База знаний (PDF/текст)',
    },
  },
};

const en = {
  nav: {
    dashboard: 'Dashboard', content: 'Content Factory', channels: 'Channels',
    exchange: 'Exchange', analytics: 'Analytics', farm: 'Farm', bots: 'Bots',
    settings: 'Settings', billing: 'Billing',
  },
  common: {
    loading: 'Loading…', error: 'Error', save: 'Save', cancel: 'Cancel',
    delete: 'Delete', edit: 'Edit', signOut: 'Sign out',
  },
  dashboard: {
    title: 'Dashboard',
    period: { '7d': '7 days', '30d': '30 days', '90d': '90 days' },
    cards: { subscribers: 'Subscribers', reach: 'Reach 7d', er: 'Average ER', scheduled: 'Scheduled', farm: 'Farm accounts' },
    chartTitle: 'Subscriber growth (30d)',
    upcomingTitle: 'Upcoming posts',
    upcomingEmpty: 'No scheduled posts',
    insightsTitle: 'AI Daily Insight',
    insight: { best: 'Best post yesterday', trend: 'Trend of the day', recommendation: 'Recommendation' },
    emptyTitle: 'Get started in 3 steps',
    emptySubtitle: 'Connect a Telegram channel and start publishing',
    startWizard: 'Launch setup wizard',
    step1: 'Connect Telegram channel',
    step2: 'Check analytics',
    step3: 'Schedule first post',
    errorLoad: 'Failed to load dashboard data',
  },
  login: {
    title: 'Sign in to teleclaw',
    email: 'Email', password: 'Password', signIn: 'Sign in', googleSignIn: 'Sign in with Google',
  },
  billing: {
    title: 'Billing & Plans',
    currentPlan: 'Current plan',
    renewsOn: 'Renews on',
    cancelSubscription: 'Cancel subscription',
    usage: { posts: 'Posts', channels: 'Channels', ai: 'AI calls' },
    choosePayment: 'Payment method',
    plans: 'Plans',
    popular: 'Popular',
    perMonth: 'mo',
    upgrade: 'Upgrade',
    farmAddons: 'Farm add-ons',
    accounts: 'accounts',
    addAddon: 'Add-on',
    history: 'Billing history',
    noHistory: 'No payments yet',
    col: { date: 'Date', amount: 'Amount', tariff: 'Tariff', status: 'Status', invoice: 'Invoice' },
    referral: {
      title: 'Referral program',
      yourLink: 'Your referral link',
      copy: 'Copy',
      invited: 'Invited',
      earned: 'Earned',
    },
    redirecting: 'Redirecting to payment…',
    chargeFailed: 'Failed to create payment',
    cancelled: 'Subscription cancelled',
    copied: 'Copied',
  },
  onboarding: {
    skip: 'Skip',
    back: 'Back',
    next: 'Next',
    finishToast: 'Welcome to teleclaw!',
    step1: {
      title: 'Channel',
      heading: 'Connect Telegram channel',
      desc: 'Enter the Bot Token issued by @BotFather. It is required to publish posts on behalf of the channel.',
      tokenLabel: 'Bot Token',
      connect: 'Validate & Connect',
      connected: 'Channel connected',
      invalid: 'Enter a valid Bot Token',
      subs: 'subscribers',
      helpLink: 'How to get a Bot Token?',
      helpTitle: 'Getting a Bot Token',
      help1: 'Open @BotFather in Telegram',
      help2: 'Send /newbot command',
      help3: 'Follow the prompts and pick a bot name',
      help4: 'Copy the issued token and paste it here',
    },
    step2: {
      title: 'Analytics',
      heading: 'Check analytics',
      baseline: 'This is your baseline — we grow from here.',
      subscribers: 'Subscribers',
      er: 'ER',
      reach: 'Reach',
      lastPost: 'Last post',
    },
    step3: {
      title: 'First post',
      heading: 'Schedule first post',
      desc: 'Write a post and pick a publish time.',
      text: 'Post text',
      publishAt: 'Publish at',
      useAi: 'Use AI',
      aiPrompt: 'What is the post about?',
      aiGenerate: 'Generate',
      aiDone: 'AI generated the text',
      schedule: 'Schedule first post',
    },
  },
  share: {
    title: 'Your first post is queued! 🎉',
    desc: 'You just scheduled your first post via teleclaw. Share the win and invite your peers.',
    shareTelegram: 'Share on Telegram',
    tgText: 'I run my channel {{handle}} with teleclaw — scheduling, analytics and growth in one place. Try it:',
    referralHeading: 'Invite & earn',
    referralDesc: 'Invite a peer — you both get bonus credits on their first payment.',
    copy: 'Copy',
    copied: 'Link copied',
    later: 'Later',
  },
  publicChannel: {
    tagline: 'Telegram Content Factory & Marketing Suite',
    subscribers: 'Subscribers',
    er: 'ER (7d)',
    growth: 'Growth (30d)',
    cta: 'Try teleclaw for free',
    notFound: 'Channel not found or hidden',
  },
  wall: {
    posts: {
      title: 'Post limit reached',
      desc: 'Free plan includes 30 posts/month. Upgrade to publish without limits.',
    },
    ai: {
      title: 'AI features unavailable on Free',
      desc: 'AI content and fine-tune are available from the Starter plan.',
    },
    channels: {
      title: 'Channel limit reached',
      desc: 'Upgrade to connect more channels.',
    },
    usage: 'Used {{used}} of {{limit}}',
    cta: 'View plans',
  },
  nps: {
    title: 'How likely are you to recommend teleclaw to a colleague?',
    notLikely: 'Not likely',
    veryLikely: 'Very likely',
    commentPlaceholder: "What could we improve? (optional)",
    submit: 'Submit',
    dismiss: 'Not now',
    thanks: 'Thanks for the feedback!',
  },
  content: {
    trends: 'Trends',
    selectChannel: 'Select channel',
    noChannel: 'Select a channel first',
    aiPlan: 'AI Plan',
    newPost: 'New post',
    untitled: '(no text)',
    empty: { trends: 'No trends yet' },
    toast: {
      created: 'Post created', updated: 'Saved', deleted: 'Deleted',
      aiImproved: 'AI updated text', planApplied: 'Plan added to calendar',
    },
    editor: {
      title: 'Post editor', text: 'Text', media: 'Media URL',
      time: 'Publish time', channel: 'Channel', schedule: 'Schedule',
      aiTitle: 'AI improve', aiRewrite: 'Rewrite', aiShorter: 'Shorter', aiCta: 'Add CTA',
    },
    plan: {
      topic: 'Topic', audience: 'Audience', days: 'Days', perDay: 'Posts per day',
      language: 'Language', generate: 'Generate', applyAll: 'Add all to calendar',
      preview: 'Suggestions',
    },
  },
  farm: {
    title: 'Farm',
    selector: 'Farm selector',
    all: 'All farms',
    importSessions: '+ Import sessions',
    runScript: 'Run script',
    locked: {
      title: 'Farm features unavailable',
      description: 'Farm features недоступны на вашем тарифе. Upgrade to access the account farm.',
      upgrade: 'Upgrade plan',
    },
    status: {
      active: 'Active', warming: 'Warming', banned: 'Banned',
      recovered: 'Recovered', idle: 'Idle',
    },
    cards: {
      total: 'Total accounts', active: 'Active', warming: 'Warming',
      banned: 'Banned', recovered: 'Recovered today',
    },
    scripts: {
      title: 'Script library',
      warm: 'Warm (30d)',
      invite_conservative: 'Invite — conservative',
      invite_aggressive: 'Invite — aggressive',
      comment: 'Comment',
      react: 'React',
      stories_mention: 'Stories Mention',
      customTitle: 'Custom script',
      customHint: 'No-code builder: Action → Delay → Condition → Loop',
    },
    table: {
      title: 'Accounts (real-time)',
      empty: 'No accounts — import sessions first',
      username: 'Username', status: 'Status', proxy: 'Proxy',
      warming: 'Warming', lastAction: 'Last action', actions: 'Actions',
    },
    details: {
      title: 'Account details',
      status: 'Status', proxy: 'Proxy', warming: 'Warming (days)',
      lastAction: 'Last action', activity: 'Activity (14d)',
      recover: 'Recover account',
    },
    proxy: {
      title: 'Proxy pool',
      success: 'Success',
      empty: 'No proxies connected',
    },
    alert: {
      banSpike: '10% accounts banned in last hour — all scripts paused',
    },
    toast: {
      imported: 'Sessions imported',
      importFailed: 'Failed to import sessions',
      scriptStarted: 'Script started',
      scriptFailed: 'Failed to start script',
      recoverQueued: 'Recovery queued',
      recoverFailed: 'Failed to start recovery',
    },
  },
  settings: {
    title: 'Settings',
    tabs: {
      profile: 'Profile', team: 'Team', whitelabel: 'White-label',
      apikeys: 'API keys', webhooks: 'Webhooks', referral: 'Referral program',
      danger: 'Danger zone',
    },
    profile: {
      email: 'Email', fullName: 'Full name', telegram: 'Telegram username',
      language: 'Language', saved: 'Profile saved',
    },
    team: {
      members: 'Members', invite: 'Invite', send: 'Send',
      colEmail: 'Email', colRole: 'Role', colJoined: 'Joined',
      empty: 'No members yet', pending: 'Pending invitations',
      noPending: 'No pending invitations', invited: 'Invitation sent',
      removed: 'Member removed',
    },
    whitelabel: {
      domain: 'Domain', logo: 'Logo', primary: 'Primary color',
      accent: 'Accent color', emailTpl: 'Email templates',
      preview: 'Preview', saved: 'White-label saved',
    },
    apikeys: {
      title: 'API keys', generate: 'Generate key',
      colName: 'Name', colPrefix: 'Prefix', colScopes: 'Scopes',
      colLastUsed: 'Last used', empty: 'No API keys',
      created: 'Key created', warning: 'Save this key now. It will not be shown again.',
      copied: 'Copied', acknowledge: 'I saved it', revoked: 'Key revoked',
    },
    webhooks: {
      title: 'Webhooks', add: 'Add webhook', events: 'Events',
      empty: 'No webhooks', lastTriggered: 'Last triggered',
      never: 'Never triggered', added: 'Webhook added',
    },
    referral: {
      code: 'Referral code', referred: 'Users referred',
      earned: 'Earned', payouts: 'Payout history',
      noPayouts: 'No payouts yet', copied: 'Copied',
    },
    danger: {
      title: 'Danger zone',
      exportTitle: 'Export all data',
      exportDesc: 'GDPR export (JSON): profile, channels, posts, subscriptions, payments, API keys. Downloads immediately.',
      exportBtn: 'Download export', exportQueued: 'Export downloaded',
      deleteTitle: 'Delete account',
      deleteDesc: 'This action is irreversible. All data will be deleted.',
      deleteBtn: 'Delete account',
      confirm1: 'Are you sure? This will delete all channels, posts, bots and subscription.',
      confirmYes: 'Yes, continue',
      typeDelete: 'Type DELETE to confirm',
      deleteFinal: 'Delete forever', deleted: 'Account deleted',
    },
  },
  bots: {
    title: 'Bots',
    create: 'Create bot',
    search: 'Search bots…',
    empty: 'No bots yet',
    namePlaceholder: 'Bot name',
    typePlaceholder: 'Type',
    status: {
      draft: 'Draft',
      deployed: 'Deployed',
      paused: 'Paused',
      error: 'Error',
    },
    type: {
      support: 'Support',
      sales: 'Sales',
      faq: 'FAQ',
      lead: 'Lead-gen',
      generic: 'Generic',
    },
    lastActivity: 'Last activity',
    open: 'Open',
    duplicate: 'Duplicate',
    delete: 'Delete',
    deploy: 'Deploy',
    pause: 'Pause',
    resume: 'Resume',
    save: 'Save',
    saved: 'Saved',
    deployed: 'Bot deployed',
    paused: 'Bot paused',
    resumed: 'Bot resumed',
    created: 'Bot created',
    deleted: 'Bot deleted',
    testRun: 'Test run',
    testInput: 'Message from user',
    testStart: 'Start test',
    testTrace: 'Trace',
    back: 'Back to list',
    nodes: {
      title: 'Node types',
      message: 'Message',
      input: 'Input',
      condition: 'Condition',
      api_call: 'API call',
      delay: 'Delay',
      payment_request: 'Payment',
      faq_query: 'FAQ',
      end: 'End',
    },
    props: {
      title: 'Properties',
      none: 'Select a node',
      text: 'Text',
      buttons: 'Buttons',
      addButton: 'Add button',
      buttonText: 'Text',
      callbackData: 'callback_data',
      variable: 'Variable name',
      validation: 'Validation type',
      operator: 'Operator',
      value: 'Value',
      url: 'URL',
      method: 'Method',
      headers: 'Headers (JSON)',
      body: 'Body (template)',
      amount: 'Amount',
      currency: 'Currency',
      planId: 'Plan ID',
      delayMs: 'Delay (ms)',
      knowledgeBase: 'Knowledge base (PDF/text)',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ru: { translation: ru }, en: { translation: en } },
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'en'],
    interpolation: { escapeValue: false },
  });

export default i18n;
